export const Wrapper = 'flex justify-end py-6'

export const ContentWrapper = 'flex w-full flex-col sm:w-[320px]'

export const SummaryItemWrapper =
  'flex w-full items-center justify-between pb-4'

export const SummaryItemName = 'font-Roboto grow'

export const SummaryItemValue = 'w-[110px] shrink-0 text-right'

export const SummaryItemPromo = 'text-errorRed'

export const SummaryItemVatWrapper =
  'border-machine2-75 flex w-full items-center justify-between border-b pb-6'

export const SummaryItemTotalPriceWrapper =
  'flex w-full items-center justify-between pt-4 font-bold'

export const SummaryItemTotalPriceIncVAT = 'font-Roboto text-mediumGray'
